module.exports = __webpack_public_path__ + "static/media/camera_off.ff15e423.svg";